import classes from "./ManageSelection.module.scss";
import { IconSecondaryButton } from "components/core/IconSecondaryButton";
import { ReactComponent as TickIcon } from "components/icons/tick.svg";
import { SelectionActionButton } from "./SelectionActionButton";
import { ReactComponent as UnlockIcon } from "components/icons/unlockRed.svg";
import { ReactComponent as LockIcon } from "components/icons/lockRed.svg";
import { ReactComponent as DeleteIcon } from "components/icons/deleteRed.svg";
import { CloseButton } from "components/buttons/CloseButton";
import { Fragment, useCallback, useState } from "react";
import DeleteGifPopup from "components/UI/Popups/DeleteGifPopup";
import { useChangeGifsPrivacyMutation } from "queries";
import { getGifIds } from "utils/gif";
import { IGif } from "services/types";

interface IProps {
  selectedIds: string[];
  gifs: IGif[];
  onClose: () => void;
  onSelectAll: () => void;
}

export const ManageSelection = (props: IProps) => {
  const { selectedIds, gifs, onClose, onSelectAll } = props;

  const [isOpenDelete, setOpenDelete] = useState<boolean>(false);

  const changeGifsPrivacy = useChangeGifsPrivacyMutation();

  const getSelectedGifs = useCallback(() => {
    return gifs.filter(gif => selectedIds.indexOf(gif.id) !== -1);
  }, [gifs, selectedIds]);

  const handleSetPrivate = useCallback(async () => {
    const ids = await getGifIds(getSelectedGifs());
    changeGifsPrivacy.mutate({ ids, value: 0 });
  }, [getSelectedGifs, changeGifsPrivacy]);

  const handleSetPublic = useCallback(async () => {
    const ids = await getGifIds(getSelectedGifs());
    changeGifsPrivacy.mutate({ ids, value: 1 });
  }, [getSelectedGifs, changeGifsPrivacy]);

  const handleOpenDelete = useCallback(() => {
    setOpenDelete(true);
  }, []);

  const handleCloseDelete = useCallback(() => {
    setOpenDelete(false);
  }, []);

  return (
    <Fragment>
      {
        selectedIds.length > 0 && (
          <div className={classes.selection}>
            <IconSecondaryButton
              icon={selectedIds.length === gifs.length ? <TickIcon /> : undefined}
              variant={selectedIds.length === gifs.length ? "active" : "default"}
              onClick={onSelectAll}
            />
            <div className={classes.countSelected}>
              <div><strong>{selectedIds.length} {selectedIds.length > 1 ? "items" : "item"}</strong></div>
              <div><span>selected</span></div>
            </div>
            <SelectionActionButton icon={<UnlockIcon />} text="Public" onClick={handleSetPublic} />
            <SelectionActionButton icon={<LockIcon />} text="Private" onClick={handleSetPrivate} />
            <SelectionActionButton icon={<DeleteIcon />} text="Delete" onClick={handleOpenDelete} />
            <CloseButton onClick={onClose}/>
          </div>
        )
      }

      {
        isOpenDelete && (
          <DeleteGifPopup
            gifs={getSelectedGifs()}
            isOpen={true}
            onClose={handleCloseDelete}
          />
        )
      }
    </Fragment>
  );
};
